import { render, staticRenderFns } from "./main-map-legend.vue?vue&type=template&id=1117983e"
import script from "./main-map-legend.vue?vue&type=script&lang=js"
export * from "./main-map-legend.vue?vue&type=script&lang=js"
import style0 from "./main-map-legend.vue?vue&type=style&index=0&id=1117983e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports